export type AgentFeature = {
  title: string;
};

export type AssistantCard = {
  id: string;
  name: string;
  role: string;
  description: string;
  accent: string;
};

export type AssistantOneSlide = {
  id: string;
  name: string;
  role: string;
  summary: string;
  accent: string;
  features: string[];
  image?: string;
};

export const navLinks = [
  { label: "Inicio", href: "#inicio" },
  { label: "Mis asistentes", href: "#asistentes" },
  { label: "Sumate", href: "https://mas10.ar/app/home" }
];

export type KelaAccionVideo = {
  id: string;
  /** Ruta en /public, ej. /kela-en-accion.mp4 */
  src: string;
  poster?: string;
  /** Opcional: pie o nombre del clip */
  title?: string;
};

export const kelaEnAccionVideos: KelaAccionVideo[] = [
  { id: "kela-1", src: "/kela-en-accion.mp4", poster: "/kela-landing.png" },
  { id: "kela-2", src: "/kela-en-accion-2.mp4", poster: "/kela-landing.png" },
  { id: "kela-3", src: "/kela-en-accion-3.mp4", poster: "/kela-landing.png" }
];

export const agentesFeatures: AgentFeature[] = [
  { title: "Entrevistas de bienvenida" },
  { title: "Notas deportivas y reportes para cuerpo tecnico" },
  { title: "Respuestas rapidas ante consultas de futbolistas" }
];

export const assistantCards: AssistantCard[] = [
  {
    id: "kelly",
    name: "KELIA",
    role: "Periodista deportiva",
    description:
      "Da la bienvenida, releva contexto del plantel y genera reportes claros para cada semana.",
    accent: "from-orange-300 to-rose-300"
  },
  {
    id: "leon",
    name: "LEON",
    role: "Analista tactico",
    description:
      "Resume el rendimiento por linea, detecta patrones y propone ajustes para el proximo partido.",
    accent: "from-sky-300 to-indigo-300"
  },
  {
    id: "santi",
    name: "SANTI",
    role: "Preparador digital",
    description:
      "Transforma objetivos en rutinas, seguimiento y alertas para sostener la intensidad del equipo.",
    accent: "from-emerald-300 to-teal-300"
  }
];

export const assistantsOneSlides: AssistantOneSlide[] = [
  {
    id: "kelia",
    name: "KELA",
    role: "Periodista Deportiva",
    summary:
      "Tu voz en la prensa: difunde lo que pasa en tu equipo dándole visibilidad a cada momento.",
    accent: "from-orange-200 to-rose-200",
    image: "/kela-landing.png",
    features: [
      "Entrevistas de bienvenida",
      "Placas gráficas de prensa",
      "Notas deportivas",
      "Datos y análisis futbolísticos tuyos y de tus rivales"
    ]
  },
  {
    id: "leon",
    name: "CHORI",
    role: "Nutricionista deportivo",
    summary:
      "Se preocupa por que rindas al máximo dentro y fuera de la cancha con alimentación adaptada a tu día a día.",
    accent: "from-sky-200 to-indigo-200",
    image: "/chori-landing.png",
    features: [
      "Consulta de objetivos deportivos",
      "Planes nutricionales personalizados",
      "Consejos de alimentación"
    ]
  },
  {
    id: "santi",
    name: "PELA",
    role: "Preparador Físico",
    summary:
      "Tu entrenador personal en +10: mejora tu rendimiento con planes a medida, para jugar mejor cada partido.",
    accent: "from-emerald-200 to-teal-200",
    image: "/pela-landing.png",
    features: [
      "Sesiones de entrenamiento personalizadas",
      "Planes adaptados a tu nivel",
      "Galería de ejercicios con tips prácticos"
    ]
  },
  {
    id: "nora",
    name: "MARTA",
    role: "Manager de equipos",
    summary:
      "Facilita la gestión en la app para delegados y equipos, asegurando perfiles completos y bien organizados.",
    accent: "from-lime-200 to-emerald-200",
    image: "/marta-landing.png",
    features: [
      "Creación de escudos",
      "Gestión de colectas",
      "Optimización de perfiles de equipos",
      "Postulaciones en el mercado de pases para buscar jugadores y equipos"
    ]
  },
  {
    id: "max",
    name: "GUILLOTE",
    role: "Manager de jugadores",
    summary:
      "Facilita la postulación al mercado de pases y el acceso a información clave sobre otros agentes.",
    accent: "from-violet-200 to-fuchsia-200",
    image: "/guillote-landing.png",
    features: [
      "Postulación al mercado de pases",
      "Redirección a otros agentes",
      "Asistencia e información para jugadores",
      "Asistencia para mantener el perfil de tu equipo completo y actualizado."
    ]
  }
];
